import { useContext } from "react"
import { Field } from "formik"
import { FormContext } from "../../context/formContext"
import { Dropdown } from "primereact/dropdown"
import DescriptionTooltip from "./helpers/DescriptionTooltip";
import styles from "../../styles/Form.module.css"
import us_states from "../../resources/us_states.json"

export default function TypeDropdownUsState({ field, block, index }) {
  const isRequired = JSON.parse(field.field_validation.required[0])
  const form = useContext(FormContext)
  const isDisabled = form ? form.blocksSaved[block] : false
  return (
    <div className={styles.field} style={{ order: index }}>
      <label className={styles.label} style={{ gap: "10px" }}>
        <span>
          {field.field_label}
          {isRequired && <span className={styles.asterisk}> *</span>}
        </span>
        {field.field_description &&
          <DescriptionTooltip
            fieldName={field.field_name}
            fieldDescription={field.field_description}
          />
        }
      </label>
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => (
          <>
            <Dropdown
              placeholder="Please select"
              name={formikField.name}
              value={formikField.value}
              onChange={formikField.onChange}
              disabled={isDisabled}
              options={us_states}
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
